module.exports = __webpack_public_path__ + "static/pepefour-0e7070601edca626e5da9b628fa6aef6.png";